import { APP_CONTEXTS } from "app/model"
import { getStore } from "app/store/store"
import { getActiveAppContext } from "app/tools/common"
import { formActionCreator } from "form/store/actions"
import { navigate } from "page/tools/navigate"
import { getAppForm } from "./common"

// return true if form is loading => means we are editing
export function closeCurrentSummary(navigateBack?: boolean): boolean {
  const appForm = getAppForm()
  if (appForm.isLoading && !navigateBack) {
    return true
  }
  const appContext = getActiveAppContext()
  getStore().dispatch(
    formActionCreator.summaryClose(appContext === APP_CONTEXTS.FORECAST_EDIT, appContext === APP_CONTEXTS.DSP_DEAL_EDIT)
  )
  if (navigateBack) {
    navigate(-1)
  }
  return true
}
